import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Row as FlexboxRow } from 'react-styled-flexboxgrid';
var propTypes = {
  /**
   * @ignore
   */
  children: PropTypes.node.isRequired
};
var RowWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "RowWrapper",
  componentId: "sc-kr4awm-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledRow = /*#__PURE__*/styled(FlexboxRow).withConfig({
  displayName: "StyledRow",
  componentId: "sc-kr4awm-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  max-width: 1272px;\n"])));

var Row = function Row(props) {
  return /*#__PURE__*/React.createElement(RowWrapper, {
    bleed: props.bleed,
    className: props.className
  }, /*#__PURE__*/React.createElement(StyledRow, props, props.children));
};

Row.propTypes = propTypes;
export default Row;